import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../App';
import { CHANGE_LANG } from '../../../Reducer';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';

import ComboBoxMaterial, { ComboBoxItem } from '../../atoms/ComboBox/ItemComboBoxMaterial';

const useStyles = makeStyles({
  paper: {
    background: '#f4d700',
    color: '#000000',
    textAlign: 'center',
  },
});

const LanguageChangeCard: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { state, dispatch } = useContext(AppContext);

  //言語リスト作成
  const languages: ComboBoxItem[] = [
    { id: 'ja', value: '日本語' },
    { id: 'en', value: 'English' },
  ];

  const [selectIndex, setSelectIndex] = useState<string>('ja');

  useEffect(() => {
    //ログイン後の初期値選択設定
    setSelectIndex(state.lang);
  }, []);

  const handleLanguageChange = (value: string) => {
    var r = languages.find((row) => row.id === value);
    if (r != undefined) {
      dispatch({
        type: CHANGE_LANG,
        payload: { lang: r.id },
      });
      setSelectIndex(value);
    } else {
      dispatch({
        type: CHANGE_LANG,
        payload: { lang: 'ja' },
      });
      setSelectIndex('ja');
    }
  };

  return (
    <Paper className={classes.paper}>
      <ComboBoxMaterial
        inputLabel={t('LanguageChangeCard.言語切替', '')}
        items={languages}
        value={selectIndex}
        defaultValue={selectIndex}
        onChange={(selected) => handleLanguageChange(selected)}
      />
    </Paper>
  );
};

export default LanguageChangeCard;
